import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react'

import { createWidget } from '../widget-utils'

export interface RowWidgetProps extends SimpleGridProps {
  isLoading?: boolean
}

/**
 * TODO: We should just name this as grid or simplegrid, but we have
 * a naming collision with AGGrid and the Tables being called Grid.
 */
export const RowWidget = ({ isLoading, ...props }: RowWidgetProps) => (
  <SimpleGrid {...props} />
)

export const RowWidgetDefinition = createWidget(RowWidget, { type: 'Row' })
